/**
 * Component: MainLayout
 * Main layout wrapper for the application
 */

import type { ReactNode } from "react";
import { MainHeader } from "../MainHeader";
import { MainSidebar } from "../MainSidebar";

interface MainLayoutProps {
	readonly title: string;
	readonly children: ReactNode;
	readonly onBack?: () => void;
}

export const MainLayout = ({
	title,
	children,
	onBack,
}: MainLayoutProps): React.JSX.Element => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-1 overflow-hidden bg-[#001a41] max-h-screen">
        <MainSidebar />
        <div className="flex-1 overflow-y-auto">
          <main className="flex-1 p-8 md:p-4 overflow-y-auto transition-[margin-left] duration-300 ease-in-out bg-white rounded-tl-3xl rounded-bl-3xl flex flex-col min-h-screen">
						<MainHeader title={title} onBack={onBack} />
            {children}
            <footer className="mt-auto pt-4 flex justify-between items-center font-medium text-sm leading-5">
              <div>
                Copyright © 2025 PT DAnS Multi Pro
              </div>
              <div className="flex gap-6">
                <a href="/privacy-policy" className="text-[#64748b] no-underline transition-colors duration-200 hover:text-[#374151]">
                  Privacy Policy
                </a>
                <a href="/terms-and-conditions" className="text-[#64748b] no-underline transition-colors duration-200 hover:text-[#374151]">
                  Terms and conditions
                </a>
                <a href="/contact" className="text-[#64748b] no-underline transition-colors duration-200 hover:text-[#374151]">
                  Contact
                </a>
              </div>
            </footer>
          </main>
        </div>
      </div>
    </div>
  );
};
